<template>
    <div :class="one ? 'container containerNew' : 'container'">
        <div class="common-header-wrap">
            <mt-header :title="$t('hunt17')" class="common-header">
                <mt-button slot="left" icon="back" @click="one ? onPage('index') : $router.go(-1)"></mt-button>
            </mt-header>
        </div>

        <img class="bg" src="../../../assets/image/one/hunt_shipping.png" alt="">
        <div class="logo"><img src="../../../assets/image/one/hunt_logo1.png" style="width: 75px;"></div>
        <div class="title">
            {{ $t('hunt17') }}
        </div>

        <div class="spp_text">
            <h2>{{ $t('ship1') }}</h2>
            <p>{{ $t('ship2') }}</p>
            <hr />

            <h2>{{ $t('ship3') }}</h2>
            <h3>{{ $t('ship4') }}</h3>
            <p>{{ $t('ship5') }}</p>
            <h3>{{ $t('ship6') }}</h3>
            <p>{{ $t('ship7') }}</p>
            <h3>{{ $t('ship8') }}</h3>
            <p>{{ $t('ship9') }}</p>
            <h3>{{ $t('ship10') }}</h3>
            <p>{{ $t('ship11') }}</p>
            <h3>{{ $t('ship12') }}</h3>
            <p>{{ $t('ship13') }}</p>
            <hr />

            <h2>{{ $t('ship14') }}</h2>
            <h3>{{ $t('ship4') }}</h3>
            <p>{{ $t('ship15') }}</p>
            <h3>{{ $t('ship8') }}</h3>
            <p>{{ $t('ship16') }}</p>
            <p>{{ $t('ship17') }}</p>
            <h3>{{ $t('ship18') }}</h3>
            <p>{{ $t('ship19') }}</p>
            <h3>{{ $t('ship20') }}</h3>
            <p>{{ $t('ship21') }}</p>
            <p>{{ $t('ship22') }}</p>
            <h3>{{ $t('ship10') }}</h3>
            <p>{{ $t('ship23') }}</p>
            <h3>{{ $t('ship12') }}</h3>
            <p>{{ $t('ship24') }}</p>
            <p>{{ $t('ship25') }}</p>
            <hr />

            <h2>{{ $t('ship26') }}</h2>
            <p>{{ $t('ship27') }}</p>
            <p>{{ $t('ship28') }}</p>
            <p>{{ $t('ship29') }}</p>

            <h3>{{ $t('ship30') }}</h3>
            <h3>{{ $t('ship31') }}</h3>
        </div>

        <div class="time">
            <span>{{ $t('hunt70') }}</span>
            <div>2024/11/1</div>
        </div>

    </div>
</template>


<script>
export default {
    name: 'HuntShipPing',
    props: {
        one: {
            default: false,
            type: Boolean
        },
    },
    data() {
        return {
        }
    },
    methods: {
        onPage(v, val) {
            this.$emit('onPage', v, val)
        },
    }
}
</script>


<style lang="scss" scoped>
.containerNew{
    height: 100% !important;
}
.logo {
    position: absolute;
    width: 100%;
    text-align: left;
    bottom: 15%;
    margin-left: 40px;
}

.container {
    display: flex;
    flex-direction: column;
    width: 100vw;
    height: 100vh;
    position: relative;

    .bg {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
    }

    .title {
        position: absolute;
        font-size: 24px;
        top: 25%;
        width: 80%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-weight: bold;
    }

    .spp_text {
        overflow-y: auto;
        width: 80%;
        position: absolute;
        top: 52%;
        height: 40%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 15px;
        line-height: 25px;
        color: #333333;
        h2{
            color: #000;
            font-size: 16px;
            font-weight: bold;
        }
        h3{
            font-weight: bold;
        }
    }

    .time {
        font-size: 14px;
        color: #fff;
        position: absolute;
        top: 80%;
        right: 10%;
        transform: translate(0, -50%);

        div {
            margin-top: 10px;
            padding: 5px 13px 3px 12px;
            background: #FFBB00;
            border-radius: 11px 11px 11px 0px;
        }
    }
}
</style>
